import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ę",
  "use": "icon-Ę-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Ę\">\n<path d=\"M24.917 37.144V22.504L37.445 29.848L24.917 37.144ZM42.533 16.408H17.477C17.477 16.408 10.901 16.408 10.901 22.984V36.616C10.901 36.616 10.901 43.192 17.477 43.192H42.533C42.533 43.192 49.157 43.192 49.157 36.616V22.984C49.157 22.984 49.157 16.408 42.533 16.408Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol